import { ActivityMarkbookTab } from '../../ActivityMarkbookTab';
import type { Activity, UnitStudent } from '../../types';

interface MarkbookTabProps {
  students: UnitStudent[];
  activities: Activity[];
}

export function MarkbookTab({ students, activities }: MarkbookTabProps) {
  return <ActivityMarkbookTab students={students} activities={activities} />;
}
